/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import Rails from "@rails/ujs";
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import '@hotwired/turbo-rails'

// Heavy libraries (chartkick, file-saver, tableexport.jquery.plugin,
// webpack-jquery-ui) are intentionally NOT imported here. They are pulled in via
// page-specific packs (app/javascript/packs/{reports,export,print_mapping}_bundle.js)
// using append_javascript_pack_tag in the views that actually need them. xlsx is
// still in the main bundle because argus/table_controller.js (autoloaded on every
// page) imports it statically — a follow-up could convert that to a dynamic import.

import 'stylesheets/application.scss'
import 'icomoon_rails/icons'

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Areas
import "./areas/areas"

// Shared
import "shared/file_input_handler"
import "shared/navbar"
import "shared/nav_search"
import "shared/tom_select"

Rails.start();

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Auto-discover every controller in app/javascript/controllers using Stimulus convention
// (folder/file path -> identifier with _ replaced by -, / replaced by --). This is the
// canonical (and only) registration path; views reference controllers by the identifier
// their file path implies. Adding a new controller does NOT require editing this file —
// drop the file, give the view a matching data-controller attribute, and it just works.
const controllerContext = require.context("../controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(controllerContext))
